'use client';

import { Header } from '@/app/components/shared/Header';
import { TopAnnouncementBar } from '@/app/components/shared/TopAnnouncementBar';
import { useIsScreen } from '@/app/hooks';
import { usePathname } from '@/i18n/routing';
import { useIsAiVideoEditorRoute } from './use-ai-video-editor-route';

export function WorkspaceTopAnnouncementBar() {
  const pathname = usePathname();
  if (pathname === '/subscription' || pathname.startsWith('/subscription/')) return null;
  return <TopAnnouncementBar className="sticky top-0 z-20 shrink-0" />;
}

export function WorkspaceRouteHeader() {
  const isAiVideoEditorRoute = useIsAiVideoEditorRoute();
  const { isMdScreen } = useIsScreen();

  if (isAiVideoEditorRoute) {
    return null;
  }

  // 桌面端（>1023px）用户工具栏与 logo 已由侧边栏承载，header 整行留空，故不渲染；
  // 移动端（≤1023px，侧边栏隐藏）仍需 header 承载汉堡菜单/头像
  if (!isMdScreen) {
    return null;
  }

  return <Header className="shrink-0" />;
}
